import { useCallback } from "react"
import { Button } from "@mezo-org/mezo-clay"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { ENABLE_SWAPS } from "#/shared/constants"

export default function SwapButton() {
  const dispatch = useDappDispatch()

  const swapModalHandler = useCallback(() => {
    if (!ENABLE_SWAPS) return

    dispatch(setOpenModal("swap"))
  }, [dispatch])

  return (
    <Button
      shape="pill"
      size="small"
      kind="secondary"
      onClick={swapModalHandler}
    >
      Swap
    </Button>
  )
}
